import clsx from 'clsx';
import { Children, PropsWithChildren, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  > {
  isSticky?: boolean;
  /**
   * className for the children container
   */
  containerClassName?: string;
}

const Footer = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>(
  ({ className, containerClassName, isSticky, children, ...rest }, ref) => {
    if (children && Children.count(children) > 0) {
      return (
        <footer
          ref={ref}
          {...rest}
          className={twMerge(
            clsx({
              'w-full flex justify-center items-center': true,
              'fixed z-10 bottom-0': isSticky,
            }),
            className,
          )}
        >
          <div
            className={twMerge(
              clsx({
                'w-full max-w-[1120px]': true,
              }),
              containerClassName,
            )}
          >
            {children}
          </div>
        </footer>
      );
    }
    return null;
  },
);

export default Footer;
